import React, { useEffect, useState } from "react"
import { PubNubProvider } from "pubnub-react"
import { Chat, ChannelList } from "@pubnub/react-chat-components"
import { AiOutlineDown } from "react-icons/ai"
import moment from "moment"
import { IoFileTrayFullOutline, IoSendSharp } from "react-icons/io5"
import { Input } from "../Form"
import Dropzone from "react-dropzone"
import Audio from "../Audio"
import { Spinner } from "../Loading"
import { PickerList } from "../PickerDropdow"
import { Button } from "../Button"
import { timestampToHumanReadable } from "../../core/utils/timestampToHumanReadable"
import { db } from "../../core/firebase"
import PhoneContainer from "../../container/PhoneContainer"
import {
  BsFiletypeCsv,
  BsFiletypeDocx,
  BsFiletypePdf,
  BsFiletypePptx,
  BsFiletypeXlsx,
} from "react-icons/bs"
import "./styles.scss"

const maxChats = 30


export const MessageChanelList = ({
  placeholder = "Pesquisar...",
  selectedChat,
  onSelectChat,
  onTab,
  tab,
  channels,
  onChange,
  tabOptions,
  loading,
  read,
  setRead,
  selectedChatUser,
  handleClick,
  onQuickFilterClick,
  isQuickFilterActive,
}) => {
  const [all, setAll] = useState(false)
  return (
    <aside className="channels-chat">
      <div>
        <TabFilter onTab={onTab} active={tab} tabOptions={tabOptions} />
        <div className="div-search">
          <Input
            onChange={(value) => onChange(value)}
            placeholder={placeholder}
            hasIcon={<i className="fi fi-rr-search"></i>}
            handleClick={handleClick}
            hasFocus={false}
          />
          <button
            className={`quick-filter-button ${isQuickFilterActive ? 'active' : ''}`}
            onClick={onQuickFilterClick}
            title="Filtrar por meu nome"
          >
            <i className="fi fi-rr-user">👤</i>
          </button>
        </div>
        <header className="chat-list-header">
          <ul className="tabs" role="tablist">
            <li
              className={`not_answer ${read ? "active" : "inactive"} tab`}
              id="unanswered"
              role="tab"
              aria-controls="unanswered">
              <a href="#unanswered" onClick={() => setRead(false)}>Não Respondidas</a>
            </li>
            <li
              className={`not_answer ${read ? "active" : "inactive"} tab`}
              id="answered"
              role="tab"
              aria-controls="answered">
              <a href="#answered" onClick={() => setRead(true)}>Respondidas</a>
            </li>
            <li className="slider" role="presentation"></li>
          </ul>
        </header>
        {!all && channels?.length > maxChats && (
          <div style={{ textAlign: "center" }}>
            {`${maxChats} de ${channels?.length} resultados. `}
            <a href="#" onClick={() => setAll(true)}>
              Mostrar todos
            </a>
          </div>
        )}
      </div>
      {!selectedChat && loading ? (
        <div className="loading-content">
          <Spinner color="primary" />
        </div>
      ) : channels.length > 0 ? (
        <div className={`chat-list ${!all && channels?.length > maxChats ? "showmore" : ""}`}>
          <ChannelList
            channels={channels.slice(
              0,
              // all || channels.length < maxChats ? channels.length : maxChats,
              all || channels.length < maxChats ? 200 : maxChats,
            )}
            className={"pn-channel teste"}
            sort={(a, b) => a.date.getTime() > b.date.getTime()}
            channelRenderer={(item) => {
              return (
                <ListChat
                  item={item}
                  selectedChatUser={selectedChatUser}
                  selectedChat={selectedChat}
                  onSelectChat={onSelectChat}
                />
              )
            }}
          />
        </div>
      ) : (
        <div className="channels-empty">
          <h3>Não há chats</h3>
        </div>
      )}
    </aside>
  )
}

export const SendMessage = ({
  pubnub,
  currentChannel,
  theme,
  chat,
  selectedChat,
  onSend,
  onKeyPress,
  messages,
  loggedUser,
  onChangeMessage,
  onSendFile,
  valueMessage,
  onChangeVoic,
  valueVoic,
  loading,
  setOpenPicker,
  openPicker,
  onDeleteMessage,
  newChat,
  createdAt,
  currentProject,
  selectedChatUser,
  rightHeader,
}) => {
  return (
    <>
      <PubNubProvider client={pubnub}>
        <Chat {...{ currentChannel, theme }}>
          {loading ? (
            <div className="class-spinner">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              {selectedChat && (
                <ChatHeader
                  selectedChat={selectedChat}
                  selectedChatUser={selectedChatUser}
                  currentProject={currentProject}
                  rightHeader={rightHeader}
                  loggedUser={loggedUser}
                />
              )}
              {!selectedChat || !chat.hasChat ? (
                verificationChat(selectedChat, chat.hasChat, newChat)
              ) : (
                <div className="div-scroller">
                  {messages
                    .filter((item) => item.idChat === chat.id)
                    .map((item) => {
                      return item.idChat === chat.id ? (
                        <div className="list-messages">
                          <div className="date-message">
                            <text className="text-date">{dateMessage(item, createdAt)}</text>
                          </div>
                          <Messages
                            loggedUser={loggedUser}
                            item={item}
                            setOpenPicker={setOpenPicker}
                            openPicker={openPicker}
                            onDeleteMessage={onDeleteMessage}
                          />
                        </div>
                      ) : null
                    })}
                </div>
              )}
              <div>
                {selectedChat && chat && chat.hasChat && (
                  <div>
                    <SendInput
                      onSend={onSend}
                      onKeyPress={onKeyPress}
                      onChangeMessage={onChangeMessage}
                      onSendFile={onSendFile}
                      value={valueMessage}
                      onChangeVoic={onChangeVoic}
                      valueVoic={valueVoic}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </Chat>
      </PubNubProvider>
    </>
  )
}

const TabFilter = ({ onTab, active, tabOptions }) => (
  <div className="class-tab">
    {tabOptions &&
      tabOptions.map((tab, index) => (
        <div
          onClick={() => onTab(tab.id)}
          className={`tab ${tab.id === active ? "active" : ""} ${
            index > 0 && index < tabOptions.length - 1 ? "mid" : ""
          } ${index === 0 ? "radius-left" : ""} ${
            index === tabOptions.length - 1 ? "radius-right" : ""
          }`}>
          <text className="tab-text">{tab?.name}</text>
        </div>
      ))}
  </div>
)

const ListChat = ({ item, selectedChat, onSelectChat }) => {

  return (
    <div
      className={`div-channel-list ${item.id === selectedChat.id ? "active" : ""}`}
      onClick={() => onSelectChat(item)}>
      <div className="div-row">
        <div className="user-image">
          <img
            className="img-avatar"
            src={
              item.image
                ? item.image
                : `https://ui-avatars.com/api/?background=random&name=${item.name}`
            }
          />
          {item && item?.unreadCount === 1 ? <div className="circle" /> : <div />}
        </div>
        <div className="user-info">
            <span className="text-title" title={item.name}>
              {item.name}
            </span>
            <span className="text-title mini" title={item.name}>
              {item.projectName}
            </span>
            <span className="text-sub" title={item.message}>
              {item && item.message && <span className="text-sub">{item.message}</span>}
          </span>
        </div>
      </div>
      <span className={`text-time ${item && item.unreadCount === 1 ? "no-read" : ""}`}>
        {item && item.date ? moment(item.date).format("DD/MM HH:mm") : ""}
      </span>
    </div>
  )
}

const SendInput = ({
  placeholder = "Enviar mensagem",
  onSend,
  onKeyPress,
  onSendFile,
  onChangeMessage,
  value,
  onChangeVoic,
  valueVoic,
}) => {
  return (
    <div className="div-input-send">
      <div className="div-input-margin">
        {valueVoic === "" || !valueVoic ? (
          <input
            placeholder={placeholder}
            className="send-input"
            onChange={(event) => onChangeMessage(event.target.value)}
            value={value}
            onKeyDown={onKeyPress}
          />
        ) : (
          <div />
        )}
        <Audio
          onChange={(value, file) => onChangeVoic(value, file)}
          value={valueVoic && valueVoic.value}
        />
        <Dropzone
          onDrop={(file) => onSendFile(file)}
          maxSize={52428800}
          noDrag={true}
          maxFiles={1}
          multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <IoFileTrayFullOutline className="send-file" title="Adicionar arquivo" />
            </div>
          )}
        </Dropzone>
        <IoSendSharp className="send-message" onClick={onSend} title="Enviar mensagem" />
      </div>
    </div>
  )
}

const ChatHeader = ({ selectedChat, loggedUser, rightHeader }) => {
  const [lastRead, setLastRead] = useState(false)
  const dateConvert = timestampToHumanReadable(
    lastRead ? lastRead : new Date(selectedChat.date).getTime(),
  )
  const [active, setActive] = useState(false)

  const loadSession = async () => {
    const session = await db
      .collection("session")
      .where("idChat", "==", selectedChat?.id)
      .get()
      .then((querySnapshot) => {
        const sessions = []
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          sessions.push({
            ...data,
            id: doc.id,
          })
        })
        return sessions[0]
      })
      .catch((e) => {
        console.log({ e })
      })

    if (session && session.date) {
      const diffHours = moment().diff(moment(session.date.toDate()), "hours")
      const isSessionActive = diffHours < 24
      setActive(isSessionActive ? moment(session.date.toDate()).add(24, "hours") : false)

      if (session.lastRead) {
        setLastRead(session.lastRead.toDate())
      }
    } else {
      setActive(false)
    }
  }

  useEffect(() => {
    if (selectedChat?.id) {
      loadSession()
    }
  }, [selectedChat?.id])

  const getTimeDisplay = () => {
    if (active) {
      return (
        <>
          {dateConvert} -{" "}
          <strong style={{ color: "green" }}>{`Sessão Ativa até as ${active.format(
            "DD/MM/YY HH:mm",
          )}`}</strong>
        </>
      )
    } else {
      return (
        <>
          {dateConvert} - <strong style={{ color: "red" }}>Sessão Inativa</strong>
        </>
      )
    }
  }

  const selectedUsers = selectedChat && selectedChat?.notLoggedUser[0]

  return (
    <div className="chat-header">
      <div className="user-header">
        <div className="user-header-info">
          <img
            className="img-avatar"
            src={`https://ui-avatars.com/api/?background=random&name=${selectedChat.name}`}
            alt="Avatar"
          />
          <div className="user-header-info-name-project">
            <h3>
              {selectedChat?.projectName ? (
                <span>
                  {selectedChat?.name} ({selectedChat?.projectName})
                </span>
              ) : (
                selectedChat?.name
              )}
            </h3>
            <span className="last-seen">
              Visto por último em{" "}
              {!selectedChat?.name?.toLowerCase()?.includes("grupo")
                ? getTimeDisplay()
                : dateConvert}
            </span>
            {selectedUsers?.terms_accepted && (
              <div className="more-info-header">
                <span>Termos aceitos em: </span>
                {selectedUsers?.terms_accepted
                  ? moment(selectedUsers?.terms_accepted).format("DD/MM/YYYY")
                  : ""}
              </div>
            )}
          </div>
        </div>
      </div>
      {selectedUsers && selectedUsers?.phone && (
        <div className="call-chat">
          <PhoneContainer
            value={selectedUsers?.phone}
            name={selectedUsers?.name}
            data={selectedUsers}
          />
        </div>
      )}
      {rightHeader}
    </div>
  )
}

const Messages = ({ loggedUser, item, setOpenPicker, openPicker, onDeleteMessage }) => (
  <div className={`messages-users ${loggedUser !== item.fromUserId ? "no-logged-user" : ""}`}>
    <div className={`div-row-messages ${loggedUser !== item.fromUserId ? "no-logged-user" : ""}`}>
      {item.deleted ? (
        <text className="deleted-message">Esta mensagem foi apagada</text>
      ) : (
        <div className="div-collumn-chat">
          <div className="div-icon-arrow">
            <text className={`text-user ${loggedUser !== item.fromUserId ? "no-logged-user" : ""}`}>
              {" "}
              {item.nameSender}
            </text>
            {loggedUser.id === item.fromUserId ? (
              <AiOutlineDown
                className={`icon-down ${loggedUser !== item.fromUserId ? "no-logged-user" : ""}`}
                style={{ marginLeft: 15 }}
                onClick={() => setOpenPicker(item)}
              />
            ) : (
              <div />
            )}
            {openPicker && openPicker.id === item.id ? (
              <PickerList setOpen={setOpenPicker} onDeleteMessage={() => onDeleteMessage(item)} />
            ) : null}
          </div>
          <div>{textVerification(item, loggedUser)}</div>
          <div className="div-time">
            <text className={`time ${loggedUser !== item.fromUserId ? "no-logged-user" : ""}`}>
              {moment(new Date(item && item.date && item.date.seconds * 1000)).format("LT")}
            </text>
          </div>
        </div>
      )}
    </div>
  </div>
)

const verificationChat = (selectedChat, hasChat, newChat) => {
  return (
    <div className="not-chat">
      {!selectedChat ? (
        <text>Escolha uma conversa para enviar mensagem</text>
      ) : !hasChat ? (
        <Button label={"Nova Conversa"} handleClick={newChat} />
      ) : (
        <div />
      )}
    </div>
  )
}

const dateMessage = (data, createdAt) => {
  const formatedDate = createdAt.filter((row) => {
    return data.date === row.date
  })
  return formatedDate[0] && formatedDate[0].createdAt
}

const MessageDocComponent = ({ item, loggedUser }) => {
  const handleAttachmentClick = () => {
    if (item.attachment) {
      window.open(item.attachment.remotePath)
    }
  }

  const getFileIcon = () => {
    if (item.attachment) {
      if (item.attachment.contentType.includes("pdf")) {
        return <BsFiletypePdf size={20} />
      } else if (item.attachment.contentType.includes(".document")) {
        return <BsFiletypeDocx size={20} />
      } else if (item.attachment.contentType.includes(".sheet")) {
        return <BsFiletypeXlsx size={20} />
      } else if (item.attachment.contentType.includes(".presentation")) {
        return <BsFiletypePptx size={20} />
      } else if (item.attachment.contentType.includes("csv")) {
        return <BsFiletypeCsv size={20} />
      }
    }
    return null
  }

  const isAttachmentValid =
    !item.attachment ||
    (!item.attachment.contentType.includes("csv") &&
      !item.attachment.contentType.includes(".presentation") &&
      !item.attachment.contentType.includes(".sheet") &&
      !item.attachment.contentType.includes(".document") &&
      !item.attachment.contentType.includes("pdf"))

  return (
    <div
      className={`message-doc ${isAttachmentValid && "invalid-doc-file"} ${
        loggedUser !== item.fromUserId ? "no-logged-user" : ""
      }`}
      onClick={handleAttachmentClick}
      title="Documento">
      {getFileIcon()}
      {isAttachmentValid ? (
        <span className="message-doc-name" title={item.message}>
          {item.message}
        </span>
      ) : (
        <span className="message-doc-name" title={item.attachment?.name}>
          {item.attachment?.name}
        </span>
      )}
    </div>
  )
}

const renderImage = (item) => <img src={item.attachment.remotePath} className="img-chat" />

const renderAudio = (item) => (
  <audio id="audio" controls src={`https://be.manejechat.com/auth/audio?url=${item.attachment.remotePath}`} className="audio-component"></audio>
)

const renderVideo = (item) => (
  <video src={item.attachment.remotePath} width="320" height="240" controls id="video" />
)

const textVerification = (item, loggedUser) => {
  if (
    item &&
    item.attachment &&
    item.attachment.contentType &&
    typeof item.attachment.contentType === "string"
  ) {
    if (item.attachment.contentType.includes("image")) {
      return renderImage(item)
    } else if (item.attachment.contentType.includes("audio")) {
      return renderAudio(item)
    } else if (item.attachment.contentType.includes("video")) {
      return renderVideo(item)
    } else {
      return <MessageDocComponent {...{ item, loggedUser }} />
    }
  } else {
    return (
      <text className={`message ${loggedUser !== item.fromUserId ? "no-logged-user" : ""}`}>
        {item.message}
      </text>
    )
  }
}

export default textVerification

const tabs = [
  { id: 0, name: "Todos" },
  { id: 1, name: "Maya" },
  { id: 2, name: "Bento" },
]
